import axios from 'axios'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'
import moment from 'moment'

export async function getDisasterByArea(condition = {}) {
  // 一定要有scenicAreaId
  if (Utils.isEmptyObject(condition.id) || Utils.isEmptyObject(condition.startTime) || Utils.isEmptyObject(condition.endTime)) {
    console.error('iisi getDisasterByArea: scenicAreaId or time is null')
    return{}
  }

  let response = {}
  let scenicAreaId = condition.id
  let scenicAreaIdQuery = `?scenicAreaId=${scenicAreaId}`
  let type = condition.type
  let typeQuery = type && type !== -1 ? `&type=${type}` : ''
  let startTime = encodeURIComponent(moment(condition.startTime).format().split('+')[0]) //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? `&startTime=${startTime}` : ''
  let endTime = encodeURIComponent(moment(condition.endTime).format().split('+')[0]) //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let endTimeQuery = endTime ? `&endtime=${endTime}` : ''

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}Disaster/GetDisasterEvent${scenicAreaIdQuery}${typeQuery}${startTimeQuery}${endTimeQuery}`)

  } catch (err) {
    console.error('iisi getDisasterByArea: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response
}


export async function getAllDisaster(condition = {}) {
  // 找全部景區與全部類型
  if (Utils.isEmptyObject(condition.startTime) || Utils.isEmptyObject(condition.endTime)) {
    console.error('iisi getAllDisaster: time is null')
    return
  }

  let response = {}
  let startTime = encodeURIComponent(moment(condition.startTime).format().split('+')[0]) //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = `?startTime=${startTime}`
  let endTime = encodeURIComponent(moment(condition.endTime).format().split('+')[0]) //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let endTimeQuery =`&endtime=${endTime}`

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}Disaster/GetAllDisasterEvent${startTimeQuery}${endTimeQuery}`)

  } catch (err) {
    console.error('iisi GetDisasterSettingByArea: ', err)
  }

  Utils.setApiResponsSuccess(response)
  if (!Utils.isEmptyObject(condition.type) && condition.type !== -1) {
    filterDisasterType(response, condition.type)
  }
  return response
}


function filterDisasterType(response, type) {
  if (Utils.isEmptyObject(response.data)) {
    return
  }

  const filterDatas = response.data.filter(elemnt => elemnt.conditionType === type)
  response.data = filterDatas
}